import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect,
  withRouter
} from 'react-router-dom'
import { Breadcrumb, Card } from 'antd';
import Dashboard from './dashboard';
import EditableTable from './projects';
import ProjectList from './projectlist';
import Events from './events';
import Login from './login';
import Media from './media';
import fakeAuth from './autha';

import "../App.css";
import { Menu, Dropdown, Layout, Button, Divider } from "antd";
const ButtonGroup = Button.Group;


const Public = () => <h2>This page is public, no sign in required.</h2>

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    fakeAuth.isAuthenticated === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const menu = (
  <Menu>
    <Menu.Item>
      <Link to='/dashboard/events'>
        Events
</Link>  </Menu.Item>
    <Menu.Item>
      <Link to='/dashboard/projects'>
        Projects
</Link> </Menu.Item>
    <Menu.Item disabled>
      Support
    </Menu.Item>
  </Menu>
);
const AuthButton = withRouter(({ history }) => (
  fakeAuth.isAuthenticated ? (
    <div>

      Welcome!
        <Divider type="vertical" />
      <Button onClick={() => {
        fakeAuth.signout(() => history.push('/'))
      }}>Sign out
      </Button>
      <Divider type="vertical" />
      <Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
        <Button type='primary' ghost>Menu</Button>
      </Dropdown>

    </div>
  ) : (
      // <p>CMS</p>
      <br></br>
    )
))








const breadcrumbNameMap = {
  '/dashboard': 'Dashboard',
  '/dashboard/events': 'Events',
  '/dashboard/projects': 'Projects',
  '/dashboard/projects/:id': 'ff',
};
const Bread = withRouter((props) => {
  const { location } = props;
  const pathSnippets = location.pathname.split('/').filter(i => i);
  // var id = pathSnippets[2];
  var name = 'a';
  if (pathSnippets.length > 3) {
    pathSnippets.splice(2, 1)
    name = pathSnippets[2];
  }

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;

    return (
      <Breadcrumb.Item key={url}>
        <Link to={index < 2 ? url : index === 2 ? name : 'not 2!'}>
          {index < 2 ? breadcrumbNameMap[url] : index === 2 ? name : 'not 2!'}
        </Link>
      </Breadcrumb.Item>
    );
  });

  const breadcrumbItems = [(
    <Breadcrumb.Item key="home">
      <Link to="/">Home</Link>
    </Breadcrumb.Item>
  )].concat(extraBreadcrumbItems);
  return (
    <Breadcrumb>
      {breadcrumbItems}
    </Breadcrumb>

  );
});










export default function AuthExample() {
  return (
    <Router>
      <div>
        <Layout className="App">
          <div className="oh">
            <AuthButton className="nq" />
          </div>
          <br />

          <Card className='crumbb'>
            <Bread />
          </Card>

          <Switch>
            <Route path="/public" component={Public} />
            <PrivateRoute exact path="/" component={Dashboard} />
            <Route path="/login" component={Login} />
            <PrivateRoute exact path='/dashboard' component={Dashboard} />

            <PrivateRoute exact path='/dashboard/projects' component={ProjectList} />
            <PrivateRoute path='/dashboard/projects/:id/:name' component={EditableTable} />

            <PrivateRoute exact path='/dashboard/events' component={Events} />
            <PrivateRoute path='/dashboard/events/:id/:title' component={Media} />


            <Route component={Login} />
          </Switch>


        </Layout>
      </div>
    </Router>
  )
}


// WEBPACK FOOTER //
// ./src/views/home.js